// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const listIndustriesApiIndustriesGetParamsActiveDefault = false;
export const ListIndustriesApiIndustriesGetParams = zod.object({
  "active": zod.boolean().default(listIndustriesApiIndustriesGetParamsActiveDefault),
  "status": zod.union([zod.enum(['approved', 'pending']),zod.null()]).optional()
})

export type ListIndustriesApiIndustriesGetParams = zod.input<typeof ListIndustriesApiIndustriesGetParams>;
export type ListIndustriesApiIndustriesGetParamsOutput = zod.output<typeof ListIndustriesApiIndustriesGetParams>;
